import { UIHeading1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AuthorCallReasons.css';

export interface IAuthorCallReasonsProps {
  contactsButton: JSX.Element;
  reasons: string[];
}
export const AuthorCallReasons: React.VFC<IAuthorCallReasonsProps> = ({ contactsButton, reasons }) => {
  return (
    <div className={styles['author-call-reasons']} data-testid="AuthorCallReasons">
      <div className={styles['content']}>
        <UIHeading1>Спросите у автора объявления</UIHeading1>
        <div className={styles['clarification']}>
          <UIText2>
            Выбрать квартиру непросто, застройщик поможет, подберет персональные условия и ответит на&nbsp;вопросы
          </UIText2>
        </div>
        <div className={styles['reasons']}>
          {reasons.map((reason, index) => (
            <div key={index} className={styles['reason']}>
              {reason}
            </div>
          ))}
        </div>
        {contactsButton}
      </div>
      <div className={styles['image']} />
    </div>
  );
};
